var $ = Dom7;

var Consts = {
    yandexApiKey: '4762e01e-6175-4c1c-9100-b2f41e0083d4',
    mapDefaultCenterCoords : '55.751574, 37.573856',
    mapObjectOptions: {
        default: {
            iconLayout: 'default#image',
            iconImageHref: '/templates/braas/img/icons/pin.png?v=1',
            iconImageSize: [30, 42],
            iconImageOffset: [-15, -42] 
        }, 
        warehouse: {
            iconLayout: 'default#image',
            iconImageHref: '/templates/braas/img/icons/pin_storage.png?v=2',
            iconImageSize: [30, 42],
            iconImageOffset: [-15, -42] 
        }, 
        bmi: {
            iconLayout: 'default#image',
            iconImageHref: '/templates/braas/img/icons/bmi_pin.svg?v=2',
            iconImageSize: [30, 41],
            iconImageOffset: [-15, -41] 
        }, 
    },
    yandexCounter: '50196379',
};

{
    let currentDate = new Date();
    let hour = currentDate.getHours();
    $("html").attr("data-time", hour >= 4 && hour <= 16 ? "day" : "evening");
}